import React from "react";
import { ids, styles } from "../modal.js";
import { View, Text, Modal, ScrollView, Linking, Platform } from "react-native";
import {
  Button,
  Divider,
  IconButton,
  Surface,
  TextInput,
  TouchableRipple,
} from "react-native-paper";
import { blackColor } from "../../../constant/constantCss.js";
import TermsCondition from "./QuickLinkComponent/TermsCondition.jsx";
import PrivacyPolicy from "./QuickLinkComponent/PrivacyPolicy.jsx";
import CancellationPolicy from "./QuickLinkComponent/CancellationPolicy.jsx";

const QuickLinkModal = ({ visible, handleClose, title, component }) => {
  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={handleClose}
    >
      <View style={styles.centeredView}>
        <Surface
          elevation={3}
          style={styles.modalView}
          dataSet={{ media: ids.modalView }}
        >
          <View style={styles.headerContainer}>
            <Text style={styles.headerText}>{title}</Text>
            <IconButton
              iconColor={blackColor}
              icon={"close"}
              onPress={handleClose}
            />
          </View>
          {/* content */}
          <ScrollView style={{ width: "100%" }}>
            <View
              style={styles.bodyContainer}
              dataSet={{ media: ids.bodyContainer }}
            >
              {component}
            </View>
          </ScrollView>
        </Surface>
      </View>
    </Modal>
  );
};

export default QuickLinkModal;
